import script from "./BaseDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseDropdown.vue?vue&type=script&setup=true&lang=js"

import "./BaseDropdown.vue?vue&type=style&index=0&id=6698b10f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6698b10f"]])

export default __exports__